import React from 'react';
import { SiriusHtmlModal } from '@web-common/components/UI/Modal/SiriusModal';
import { useActions, useAppSelector } from '@web-common/state/createStore';
import { actions as LoginActions } from '@web-common/state/reducer/loginReducer';
import styles from './bindMobile.module.scss';
import MobileValidate from '../validate/mobile';
import { getIn18Text } from 'api';
const MobileBindModal = props => {
    const { onSuccess, isBind, isUpdate, defaultMobile, defaultArea } = props;
    const { visibleMobileBindModal } = useAppSelector(state => state.loginReducer);
    const { setVisibleMobileBindModal } = useActions(LoginActions);
    const onValidateSuccess = () => {
        setVisibleMobileBindModal(false);
        onSuccess();
    };
    const title = isBind || isUpdate ? getIn18Text('BANGDINGNINDESHOU') : getIn18Text('JIEBANGXUYANZHENG');
    return (React.createElement(SiriusHtmlModal, { destroyOnClose: true, visible: visibleMobileBindModal, width: 476, onCancel: () => setVisibleMobileBindModal(false) },
        React.createElement("div", { className: styles.wrap },
            React.createElement("div", { className: styles.title }, title),
            React.createElement(MobileValidate, { from: "account", hideMobileInput: !isBind && !isUpdate, onSuccess: onValidateSuccess, isBind: isBind, isUpdate: isUpdate, defaultMobile: defaultMobile, defaultArea: defaultArea }))));
};
export default MobileBindModal;
